import React from 'react';
import { useCallbackRef } from '../useCallbackRef/useCallbackRef.js';

const useUncontrolledState = ({ defaultValue, onChange, }) => {
    const _state = React.useState(defaultValue);
    const [value] = _state;
    const previousValue = React.useRef(value);
    const _onChange = useCallbackRef(onChange);
    React.useEffect(() => {
        if (previousValue.current === value)
            return;
        _onChange(value);
        previousValue.current = value;
    }, [value, previousValue, _onChange]);
    return _state;
};
const useControllableState = ({ value, defaultValue, onChange, }) => {
    const [_value, _setValue] = useUncontrolledState({
        defaultValue,
        onChange,
    });
    const isControlled = value !== undefined;
    const __value = isControlled ? value : _value;
    const _onChange = useCallbackRef(onChange);
    const setValue = React.useCallback(previous => {
        if (isControlled) {
            const setter = previous;
            const next = typeof previous === 'function' ? setter(value) : previous;
            if (next !== value)
                _onChange(next);
        }
        else {
            _setValue(previous);
        }
    }, [isControlled, value, _setValue, _onChange]);
    return [__value, setValue];
};

export { useUncontrolledState as UNSTABLE_useUncontrolledState, useControllableState };
//# sourceMappingURL=useControllableState.js.map
